import { atom } from "jotai";

export interface QueueHealth {
  overdue: number;
  dueToday: number;
  atRisk: number;
  completedToday: number;
}

export const queueHealthAtom = atom<QueueHealth>({
  overdue: 0,
  dueToday: 0,
  atRisk: 0,
  completedToday: 0,
});

export const unreadNotificationsAtom = atom(0);
